<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Become A Teacher</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Become a teacher</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="BecomeATeacher">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'BecomeATeacherList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group ">
                    <label class="control-label">Name</label>
                    <input type="text" id="name" name="name"
                           v-model="value.name" class="form-control name"
                           placeholder="Name">
                    <div class="help text-danger" v-show="errors.has('name')">
                      {{ errors.first("name") }}
                    </div>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Mobile No</label>
                    <input type="text" id="mobile_no" name="mobile_no"
                           v-model="value.mobile_no" class="form-control mobile_no"
                           placeholder="Mobile No">
                    <div class="help text-danger" v-show="errors.has('mobile_no')">
                      {{ errors.first("mobile_no") }}
                    </div>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Email</label>
                    <input type="text" id="email" name="email"
                           v-model="value.email" class="form-control email"
                           placeholder="Email">
                    <div class="help text-danger" v-show="errors.has('email')">
                      {{ errors.first("email") }}
                    </div>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Linked In</label>
                    <input type="text" id="linked_in" name="linked_in"
                           v-model="value.linked_in" class="form-control linked_in"
                           placeholder="Linked In">
                    <div class="help text-danger" v-show="errors.has('linked_in')">
                      {{ errors.first("linked_in") }}
                    </div>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Contact status</label>
                    <div class="form-group">
                      <el-select
                        v-model="value.is_verified"
                        name="is_verified"
                        placeholder="select status"
                        style="width: 100%"
                      >
                        <el-option v-for="item in [
                                { value: 'yes', label: 'Yes' },
                                { value: 'no', label: 'No' }
                              ]"
                                   :key="item.value"
                                   v-bind:class="{'has-error': errors.has('is_verified')}"
                                   :label="item.label"
                                   :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <div class="help text-danger" v-show="errors.has('is_verified')">
                        {{ errors.first("is_verified") }}
                      </div>
                    </div>
                  </div>
<!--                  <div class="col-md-12">
                    <h4 class="site-heading my-3"><span>CV</span></h4>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="cv"></label>
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="input-group">
                          <div class="custom-file">
                            <input type="file"
                                   name="cv" class="custom-file-input" id="cv" @change="select_file_cv">
                            <label class="custom-file-label" for="cv">{{ value.cv_name }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>-->
                  <div class="form-group ">
                    <label class="control-label">Short Notes</label>
                    <input type="text" id="notes" name="notes"
                           v-model="value.notes" class="form-control notes"
                           placeholder="Short notes">
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "BecomeATeacherForm",
  metaInfo: {
    title: "BecomeATeacher | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {

      cv: '', cv_name: 'Choose file'
    },
    pre: {}
  }),
  methods: {

    select_file_cv: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
          this.value.cv = reader.result;
          this.$set(this.value, 'cv_name', event.target.files[0].name)
        };
      } catch (e) {
        //console.log(e);
      }
    },


    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/becomeateachers";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/becomeateachers/" + _this.$route.params.id
            method = "PUT";
          }


          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "BecomeATeacherList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/becomeateachers/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });

        this.value.cv = ''
      }

      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

